import React from 'react'
import Select from 'react-select'

export default function WidgetEmployeeMultiSelector({ onChange, Employees, value, isDisabled }) {
  return (
    <Select
      isMulti
      options={Employees}
      placeholder="Please Select"
      onChange={(options) => onChange(options || [])}
      value={value}
      isDisabled={isDisabled}
    />
  )
}
